/**
 * Gets current window._pageTimings object for reporting to MS Performance Analyzer Service
 */
export function getPageTimings() {
    var pageTimings = window._pageTimings || (window._pageTimings = {});
    return pageTimings;
}
//# sourceMappingURL=getPageTimings.js.map